export const ACTIVES = [
  { label: 'EURUSD', value: 1 },
  { label: 'EURGBP', value: 2 },
  { label: 'GBPJPY', value: 3 },
  { label: 'EURJPY', value: 4 },
  { label: 'GBPUSD', value: 5 },
  { label: 'USDJPY', value: 6 },
  { label: 'AUDCAD', value: 7 },
  { label: 'NZDUSD', value: 8 },

  { label: 'AUDUSD', value: 99 },
  { label: 'USDCAD', value: 100 },
  { label: 'AUDJPY', value: 101 },
  { label: 'GBPCAD', value: 102 },
  { label: 'GBPCHF', value: 103 },
  { label: 'GBPAUD', value: 104 },
  { label: 'EURCAD', value: 105 },
  { label: 'CHFJPY', value: 106 },
  { label: 'CADCHF', value: 107 },
  { label: 'CADJPY', value: 945 },
  { label: 'EURAUD', value: 108 },
  { label: 'GBPNZD', value: 947 },
  { label: 'EURNZD', value: 212 },
  { label: 'USDCHF', value: 72 },

  { label: 'EURUSD-OTC', value: 76 },
  { label: 'EURGBP-OTC', value: 77 },
  { label: 'USDCHF-OTC', value: 78 },
  { label: 'EURJPY-OTC', value: 79 },
  { label: 'NZDUSD-OTC', value: 80 },
  { label: 'GBPUSD-OTC', value: 81 },
  { label: 'EURRUB-OTC', value: 82 },
  { label: 'USDRUB-OTC', value: 83 },
  { label: 'GBPJPY-OTC', value: 84 },
  { label: 'USDJPY-OTC', value: 85 },
  { label: 'AUDCAD-OTC', value: 86 },

  { label: 'BTCUSD', value: 816 },
  { label: 'XEMUSD-L', value: 1120 },
  { label: 'ETHUSD', value: 818 },
  { label: 'IOTUSD-L', value: 1116 },
  { label: 'EOSUSD-L', value: 1244 },
  { label: 'QTMUSD', value: 845 },
  { label: 'BCHUSD-L', value: 836 },
  { label: 'TRXUSD', value: 858 },
  { label: 'XRPUSD-L', value: 1122 },
  { label: 'XLMUSD-L', value: 1117 },
  { label: 'ETHUSD-L', value: 831 },
  { label: 'ZECUSD', value: 826 },
  { label: 'LTCUSD', value: 819 },
  { label: 'BCHUSD', value: 824 },
  { label: 'NEOUSD-L', value: 1118 },
  { label: 'OMGUSD', value: 825 },
  { label: 'DSHUSD', value: 821 },
  { label: 'LTCUSD-L', value: 834 },
  { label: 'XRPUSD', value: 817 },

  { label: 'USDNOK', value: 168 },
  { label: 'EURRUB', value: 9 },
  { label: 'USDRUB', value: 10 },
  { label: 'COMMBK', value: 13 },
  { label: 'DAIM', value: 14 },
  { label: 'DBFRA', value: 15 },
  { label: 'EOAN', value: 16 },

  { label: 'AMAZON', value: 31 },
  { label: 'APPLE', value: 32 },
  { label: 'BAIDU', value: 33 },
  { label: 'CISCO', value: 34 },
  { label: 'FACEBOOK', value: 35 },
  { label: 'GOOGLE', value: 36 },
  { label: 'INTEL', value: 37 },
  { label: 'MSFT', value: 38 },

  { label: 'YAHOO', value: 40 },
  { label: 'AIG', value: 41 },
  { label: 'BOA', value: 42 },

  { label: 'BPLON', value: 23 },

  { label: 'GAZPROM', value: 27 },
  { label: 'ROSNEFT', value: 28 },
  { label: 'SBERS', value: 29 },

  { label: 'CITI', value: 45 },
  { label: 'COKE', value: 46 },
  { label: 'GM', value: 49 },
  { label: 'GS', value: 50 },
  { label: 'JPM', value: 51 },
  { label: 'MCDON', value: 52 },
  { label: 'MORSTAN', value: 53 },
  { label: 'NIKE', value: 54 },

  { label: 'VERIZON', value: 56 },
  { label: 'WMART', value: 57 },

  { label: 'DAX30', value: 66 },
  { label: 'DJIA', value: 67 },
  { label: 'FTSE', value: 68 },
  { label: 'NSDQ', value: 69 },
  { label: 'NK', value: 70 },
  { label: 'SP', value: 71 },
  { label: 'BTCX', value: 73 },
  { label: 'XAUUSD', value: 74 },
  { label: 'XAGUSD', value: 75 },

  { label: 'ALIBABA', value: 87 },

  { label: 'YANDEX', value: 95 },

  { label: 'PAN', value: 97 },

  { label: 'BMW', value: 110 },
  { label: 'LUFTHANSA', value: 111 },

  { label: 'TWITTER', value: 113 },

  { label: 'FERRARI', value: 133 },

  { label: 'SMI INDEX', value: 166 },
  { label: 'TESLA', value: 167 },

  { label: 'SSE INDEX', value: 169 },
  { label: 'HANG SENG', value: 170 },

  { label: 'SPASX200', value: 208 },
  { label: 'TOPIX500', value: 209 },
  { label: 'DX', value: 210 },

  { label: 'SIN-FAKE', value: 213 },

  { label: 'BRENT OIL JUL 16', value: 215 },

  { label: 'NTDOY', value: 218 },
  { label: 'USDSEK', value: 219 },
  { label: 'USDTRY', value: 220 },

  { label: 'SNAPCHAT', value: 756 },
  { label: 'DFMGI', value: 757 },
  { label: 'TELAVIV', value: 758 }
]



// WEBPACK FOOTER //
// ./src/utils/currencies/constants-iq-option.js